module.exports = __webpack_public_path__ + "static/media/6.13be45a1.svg";